<template>
  <div>
    Пациенту {{ message.patient_name }} выставлен счет<br>
    <button v-on:click="onClick" type="button">
      <router-link class="server-message__link" v-bind:to="navigateToInvoice">
        Перейти к оплате
      </router-link>
    </button>
  </div>
</template>

<script>

/**
 * @description Название события счет сформирован.
 * @type {String}
 */
export const EVENT_INVOICE_CREATING = 'invoice-creating';

/**
 * @typedef {Object} Message Сообщение.
 * @property {Number} patient_id
 * @property {String} patient_name
 * @property {String} invoice_id
 */

/**
 * @description Компонент серверного сообщения счет сформирован.
 */
export default {
  computed: {
    navigateToInvoice() {
      return {
        name: 'ClinicPanelPatientInvoice',
        params: { id: this.message.patient_id, invoiceId: this.message.invoice_id },
      };
    },
  },
  methods: {
    onClick() {
      this.$emit('hide');
    },
  },
  name: 'ServerMessageInvoiceCreating',
  props: {
    message: { required: true, type: Object },
  },
};
</script>
